let theme = {
  overlayBackdrop: 'rgba(0,0,0,0.3)'
};
export default theme;
